import React from 'react';
import { RefreshCw } from 'lucide-react';

const Header = ({ onRefresh, refreshing, totalCount }) => {
  return (
    <div className="flex justify-between items-center mb-6">
      <div className="flex items-center space-x-4">
        {/* Ownli Icon/Logo */}
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-purple-600 rounded-lg flex items-center justify-center">
            <div 
            className="w-10 h-10 rounded-lg bg-cover bg-center"
            style={{
              backgroundImage: 'url("https://parked.blob.core.windows.net/ownli/www/logos/logo.png")',
              backgroundPosition: 'center center'
            }}
          ></div>
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Ownli</h1>
            <p className="text-sm text-gray-500">Document Verification</p>
          </div>
        </div>
        
        <button
          className="h-8 w-8 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-50 transition-colors"
          onClick={onRefresh}
          disabled={refreshing}
          title="Refresh document list"
        >
          <RefreshCw
            className={`h-4 w-4 ${refreshing ? "animate-spin" : ""}`}
          />
        </button>
      </div>

      <div className="flex items-center gap-3 ml-4">
        <div className="text-sm text-gray-600">
          {totalCount} total documents
        </div>
      </div>
    </div>
  );
};

export default Header;